import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useState } from 'react';
import { useFileManagerModalInputDialogContentContext } from './FileManagerModalInputDialogContentProvider';
interface FileManagerModalInputDialogUploadCreateFolderProps {
}
const FileManagerModalInputDialogUploadCreateFolder = ({ ...props }: FileManagerModalInputDialogUploadCreateFolderProps) => {
  const { group, sub, reload } = useFileManagerModalInputDialogContentContext();
  const [folderName, setFolderName] = useState('');

  const handleCreateFolderClick = (e: any) => {
    fetch(`/api/file-system/sub-create/${group}?sub=${sub.join('/')}`, { method: 'POST', body: JSON.stringify({ folderName }) }).then(() => {
      reload();
      // setList([]);
    });
  }
  (window as any)['handleCreateFolderClick'] = handleCreateFolderClick;

  return (
    <Box style={{ background: 'darkgray', minHeight: '64px' }}>
      <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
        <InputLabel htmlFor="outlined-foldername">Folder Name</InputLabel>
        <OutlinedInput
          id="outlined-foldername"
          type={'text'}
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="create folder"
                onClick={handleCreateFolderClick}
                edge="end"
              >
                <CreateNewFolderIcon />
              </IconButton>
            </InputAdornment>
          }
          label="Password"
        />
      </FormControl>
    </Box>
  )
}

export default FileManagerModalInputDialogUploadCreateFolder;
